import { SpinnerCircular } from "spinners-react";
import { Dialog } from "../../components/CommonComponents/Dialog/Dialog";
import { usePlotShapes } from "../../hooks/level-2-payment-approval.hooks";
import { usePlotShapes as level3PlotShapes } from "../../hooks/level-3-payment-approval.hooks";

export default function SelectPlotShape({
  onClose,
  onSelect,
  selected,
  isLevel3 = false
}: {
  onClose: () => unknown;
  selected?: string;
  onSelect: (data: string) => unknown;
  isLevel3?: boolean
}) {
  const { isFetching, isError, data } = isLevel3 ? level3PlotShapes() : usePlotShapes();

  let toRender = null;

  console.log("data for plot shape", data);
  
  if (isFetching || isError) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        {isError ? (
          <p>Something went wrong while fetching info!</p>
        ) : (
          <SpinnerCircular />
        )}
      </div>
    );
  } else if (!data?.length) {
    toRender = (
      <div className="flex justify-center items-center p-8">
        <p>No Plot Shapes Available!</p>
      </div>
    );
  } else {
    toRender = (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
        {data?.map((e) => (
          <button
            key={e.id}
            type="button"
            onClick={() => onSelect(e.plot_shape)}
            className={`p-4 flex justify-center items-center rounded-lg ${
              selected === e.plot_shape ? "bg-primary" : "bg-white"
            } hover:bg-gray-200 transition-colors`}
          >
            <img src={e?.plot_shape} className="max-w-full h-auto" alt='shape' />
          </button>
        ))}
      </div>
    );
  }

  return (
    <Dialog onClose={onClose} open className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-0  flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 w-full max-w-3xl max-h-[90vh] overflow-auto">
      <div className="mb-4 flex justify-between items-center relative">
  <div className="absolute right-0">
    <button className="text-xl p-2" onClick={onClose}>
      <i className="fa fa-close"></i>
    </button>
  </div>
  <h4 className="m-0 text-2xl font-bold w-full text-center">Select Plot Map</h4>
</div>
        {toRender}
      </div>
    </Dialog>
  );
}